import { Box } from "@mui/material";

const NumberChip = ({ number }) => {
  return (
    <Box
      component="span"
      sx={{
        width: 32,
        height: 32,
        borderRadius: "50%",
        bgcolor: "primary.main",
        color: "primary.contrastText",
        fontSize: "0.85rem",
        fontWeight: 600,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
        userSelect: "none",
        mr: 1.5,
      }}
    >
      {number}
    </Box>
  );
};
export default NumberChip;
